import { useIntl } from 'react-intl';

import { Actions } from '~/eds/src/components/Actions/Actions';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Markdown } from '~/eds/src/components/Markdown/Markdown';
import { Tooltip } from '~/eds/src/components/Tooltip/Tooltip';
import { User } from '~/eds/src/components/User/User';
import { User as EdsUser } from '~/eds/src/types/User';
import { UserAction } from '~/eds/src/types/UserAction';
import { getUserName } from '~/eds/src/utils/getUserName';
import { useFormatDate } from '~/i18n/hooks/useFormatDate/useFormatDate';

import { Message as MessageType } from '../types/chat';

interface Props {
  message: MessageType;
  actions?: UserAction[];
  user: EdsUser;
}

export const UserMessage = ({ actions, message, user }: Props) => {
  const intl = useIntl();
  const formatDate = useFormatDate();
  const { text, timestamp } = message;
  const tooltip = `${getUserName({ user, intl })}\n${formatDate(
    timestamp,
    'short_datetime',
  )}`;

  return (
    <Layout justify="space-between" align="center">
      <Layout align="center" spacing={4}>
        <Layout alignSelf="flex-start">
          <Tooltip tooltip={tooltip} placement="left">
            <User
              mode="avatar"
              user={user}
              options={{ disableTooltip: true }}
            />
          </Tooltip>
        </Layout>
        <Layout align="center" spacing={2}>
          <Markdown variant="body-medium" text={text} />
        </Layout>
      </Layout>

      <Layout alignSelf="flex-start">
        {actions && <Actions actions={actions} />}
      </Layout>
    </Layout>
  );
};
